import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'py-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  standalone: false,
})
export class StepperComponent implements OnInit {
  private _activeStep: number;
  public largestStep: number = this.activeStep;

  @Input() set activeStep(activeStep: number) {
    this._activeStep = activeStep;
    if (this.largestStep < activeStep || !this.largestStep) {
      this.largestStep = activeStep;
    }
  }

  get activeStep(): number {
    return this._activeStep;
  }

  @Input()
  numberOfSteps: number;

  @Input()
  clickable: boolean = true;

  @Output()
  selectedStep = new EventEmitter<number>();

  get steps() {
    return Array.from({ length: this.numberOfSteps }, (_, i) => i + 1);
  }

  constructor() {}

  ngOnInit(): void {}

  selectStep(step: number) {
    if (this.clickable && this.activeStep !== step && step <= this.largestStep) {
      this.activeStep = step;
      this.selectedStep.emit(step);
    }
  }
}
